
import { KanbanColumn } from "./KanbanColumn";
import { KanbanStage, KanbanCandidate } from "./types/index";

interface DraggableKanbanBoardProps {
  stages: KanbanStage[];
  candidatesByStage: Record<string, KanbanCandidate[]>;
  onCandidateDrop: (candidateId: string, targetColumnId: string) => void;
}

export const DraggableKanbanBoard = ({ 
  stages, 
  candidatesByStage, 
  onCandidateDrop 
}: DraggableKanbanBoardProps) => {
  
  const handleDragStart = (e: React.DragEvent, candidateId: string, sourceColumnId: string) => {
    e.dataTransfer.setData("candidateId", candidateId);
    e.dataTransfer.setData("sourceColumnId", sourceColumnId);
  };
  
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };
  
  const handleDrop = (e: React.DragEvent, targetColumnId: string) => {
    e.preventDefault();
    const candidateId = e.dataTransfer.getData("candidateId");
    const sourceColumnId = e.dataTransfer.getData("sourceColumnId");
    
    if (sourceColumnId !== targetColumnId) {
      onCandidateDrop(candidateId, targetColumnId);
    }
  };
  
  return (
    <div className="flex space-x-4 overflow-x-auto pb-4">
      {stages.map(stage => (
        <KanbanColumn
          key={stage.id}
          id={stage.id}
          title={stage.name}
          candidates={candidatesByStage[stage.id] || []}
          onDragStart={handleDragStart}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        />
      ))}
    </div>
  );
};
